// List — sum of Empty and NonEmpty<A>. Matchable ADT for when
// "is-it-empty" is a load-bearing domain fact.
//
// The tail is a flat readonly array (not a cons-cell) — matches
// what the rest of the codebase uses and lets `.map` / `.filter` /
// spread work on `.tail` without conversion.
//
// Use `List<A>` in a field type when the aggregate cares about
// empty-vs-nonempty as a distinction (e.g. "at least one
// LearningObjective"). Reach for plain `readonly A[]` when the
// distinction doesn't matter.
export { empty, fromArray, head, isEmpty, isNonEmpty, map as mapList, match as matchList, nonEmpty, tail, toArray, };
const empty = { _tag: "List.Empty" };
const nonEmpty = (head, tail = []) => ({
    _tag: "List.NonEmpty",
    head,
    tail,
});
const isEmpty = (l) => l._tag === "List.Empty";
const isNonEmpty = (l) => l._tag === "List.NonEmpty";
// fromArray — canonical builder from a possibly-empty array.
const fromArray = (xs) => {
    if (xs.length === 0)
        return empty;
    // Destructure rather than `xs[0] as A`: the cast is a no-op today
    // but would silently become a lie under noUncheckedIndexedAccess.
    const [head, ...rest] = xs;
    return nonEmpty(head, rest);
};
// toArray — flatten back to a plain array (Empty → []).
const toArray = (l) => isEmpty(l) ? [] : [l.head, ...l.tail];
// head / tail — total accessors on NonEmpty; distinct calls signal
// intent at the read site.
const head = (l) => l.head;
const tail = (l) => l.tail;
const map = (f) => (l) => isEmpty(l) ? l : nonEmpty(f(l.head), l.tail.map(f));
const match = (cases) => (l) => isEmpty(l) ? cases.empty() : cases.nonEmpty(l);
//# sourceMappingURL=list.js.map